import * as z from "zod";

import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const referenceObject = () =>
  z
    .object({
      id: requiredString(),
    })
    .or(z.literal(undefined))
    .or(z.literal(null))
    .refine((val) => !!val && !!val.id?.trim(), {
      message: REQUIRED_MESSAGE,
    });

export const statisticSchema = z.object({
  label: requiredString(),
  value: requiredString(),
});

export const projectSchema = z.object({
  name: requiredString().nonempty("Project cannot be empty"),
  alias: z.optional(z.string()).nullable(),
  logo: z.optional(z.string()).nullable(),
  project_id: requiredString(),
  client: referenceObject(),
  account_manager: referenceObject(),
  sales_coordinator: referenceObject(),
  coordinator: referenceObject(),
  legal_entity: requiredString(),
  industry: z.optional(z.string()).nullable(),
  countries: z.optional(z.array(z.string())).nullable(),
  start_date: z.optional(z.string()).nullable(),
  end_date: z.optional(z.string()).nullable(),
  about: z.optional(z.string()).nullable(),
  statistics: z.optional(z.array(statisticSchema)).nullable(),
  // description: z.string(),
  status: requiredString(),
  tags: z.optional(z.any()).nullable(),
});
